import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router';
import Dropzone from 'react-dropzone';

const spinner = (
  <div className="text-center">
    <i className="fa fa-spinner fa-pulse fa-5x fa-fw" />
    <span className="sr-only">Loading...</span>
  </div>
);

function seconds2Days(seconds) {
  const days = Number.parseInt(seconds, 10) / 86400;
  return `${days} days`;
}
class RoutingWidget extends React.Component {
  render() {
    let routing;
    if (this.props.tour.tour_stops.length > 0) {
      const duration = seconds2Days(this.props.tour.duration);
      const state = this.props.tour.state === 'DR' && !this.props.readOnly;
      routing = (
        <div>
          <p>{this.props.tour.shows} shows.</p>
          <p>{this.props.tour.cities} cities.</p>
          <p>{duration}.</p>
          {state && (
            <p>
              <Button bsStyle="info" onClick={this.props.clearRoute}>
                <i className="fa fa-trash" /> Clear Route
              </Button>
            </p>
          )}
        </div>
      );
    } else {
      let text;
      if (this.props.isProcessing) {
        text = spinner;
      } else {
        text = (
          <div className="text-center">
            Drop your route spreadsheet here, or click to select files to upload.
            <br />
            <i className="fa fa-file-excel-o fa-5x" aria-hidden="true" />
          </div>
        );
      }
      routing = (
        <div>
          <Dropzone
            ref={node => {
              this.dropzone = node;
            }}
            onDrop={this.props.onDrop}
          >
            <div>{text}</div>
          </Dropzone>
          <Link to="/Example_Tour-Routing.xlsx" target="_blank">
            Download Template
          </Link>
        </div>
      );
    }
    return (
      <div className="col-sm-3">
        <Panel header="Routing">{routing}</Panel>
      </div>
    );
  }
}
export default RoutingWidget;



// WEBPACK FOOTER //
// src/routes/tours/components/widgets/RoutingWidget.js